/*
 *  This document is the CONFIDENTIAL PROPERTY of Corero Network Security, Inc.
 *  Copyright (C) 2024-2024 by Corero Network Security, Inc. All rights reserved.
 *  Notice of copyright on this document does not constitute publication.
 */

import React, { Component } from 'react';
import {Button} from 'react-bootstrap';
import './SimpleButton.scss';

class SimpleButton extends Component {

    render() {
        let {click, title, className, style} = this.props;
        className = className ? className + ' btn-simple' : 'btn-simple'; 
        return (
                <Button variant="secondary" className={className} style={style} onClick={click}>{this.props.children}{title}</Button>
        );
    }
}
export default SimpleButton;